import { render, staticRenderFns } from "./WalletCreditModal.vue?vue&type=template&id=195ab919&"
import script from "./WalletCreditModal.vue?vue&type=script&lang=js&"
export * from "./WalletCreditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports